import React, { useState, useEffect } from 'react';
import { notification } from '../../hocs/notification';
import { mainurl, imgurl } from '../../../Mainurl';
import axios from 'axios';
import { FaCheckCircle, FaUser, FaMapMarkerAlt, FaSeedling, FaCalendarAlt, FaChartLine, FaEye, FaTractor, FaClipboardList, FaRegCircle, FaRegCheckCircle } from 'react-icons/fa';
import { FaCircleHalfStroke } from 'react-icons/fa6';
import { BiLeaf, BiDroplet , BiTestTube } from 'react-icons/bi';

import HarvestData from './HarvestData';
import ExtraActivity from './ExtraActivity';
import SoilTest from './SoilTest';

import { Row, Col, Card, Alert, CardHeader, CardBody, Modal, ModalHeader, ModalBody, Badge, Button } from 'reactstrap';

const TraceabilityDetail = ({ data, ...props }) => {
    const [loading, setLoading] = useState(false);
    const [report, setReport] = useState('');
    const [viewModal, setViewModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('Details');
    const [extraActList, setExtraActList] = useState('');
    const [modalData, setModalData] = useState('');

    useEffect(() => {
        get_traceability_details();
        get_extra_activity_list();
    }, []);

    const get_traceability_details = () => {
        if (data.phase_detail !== null) {
            let pop_m_p_details = data.phase_detail.map(function (row1, index1) {
                if (true) {
                    let status = "Incomplete";
                    let completedCount = 0;
                    let totalCount = row1.field_detail.length;
                    
                    let pop_msrng_id = row1.field_detail.map(function (row2, index2) {
                        if (row2.md_value_ac !== '') {
                            completedCount++;
                        }
                        return (
                            <tr key={index2} className="sub-detail-row">
                                <td className="fw-semibold">{row2.m_desc}</td>
                                <td className="text-muted">{row2.md_value_p}</td>
                                <td className="fw-bold text-success">
                                    {(row2.md_value_ac === '' || row2.md_value_ac === null) ? 
                                        <span className="text-muted">Not recorded</span> : 
                                        `${row2.md_value_ac} ${row2.uom_desc}`
                                    }
                                </td>
                                <td className="fw-bold text-primary">
                                    {(row2.md_date_ac === '' || row2.md_date_ac === null) ? 
                                        <span className="text-muted">-</span> : 
                                        date_format(row2.md_date_ac)
                                    }
                                </td>
                            </tr>
                        )
                    });

                    status = completedCount === totalCount ? "Complete" : 
                             completedCount > 0 ? "Partial" : "Incomplete";

                    let toggleDataHandler = (e) => {
                        if (!e.currentTarget.nextSibling.classList.contains('is-visible')) {
                            const allElements = document.getElementsByClassName('subActivity');
                            for (let i = 0; i < allElements.length; i++) {
                                allElements[i].classList.remove("is-visible");
                            }
                            e.currentTarget.nextSibling.classList.add("is-visible");
                        } else {
                            e.currentTarget.nextSibling.classList.remove("is-visible");
                        }
                    }

                    let tickMark;
                    let statusColor = "secondary";
                    
                    if (row1.actual_date === null || row1.actual_date === " " || row1.actual_date === undefined) {
                        tickMark = <div className="status-indicator pending"></div>;
                    } else {
                        let rDate = new Date(row1.seq_cal_day + " 00:00:00");
                        let aDate = new Date("2022-09-01 00:00:00");
                        if ((rDate - aDate) >= 0) {
                            tickMark = <FaCheckCircle color="#28a745" size={20} />;
                            statusColor = "success";
                        } else {
                            tickMark = <FaCheckCircle color="#dc3545" size={20} />;
                            statusColor = "danger";
                        }
                    }

                    const getStatusBadge = (status) => {
                        const badgeProps = {
                            Complete: { color: "success", icon: <FaRegCheckCircle size={20} /> },
                            Partial: { color: "warning", icon: <FaCircleHalfStroke size={20} /> },
                            Incomplete: { color: "danger", icon: <FaRegCircle size={20} /> }
                        };
                        const props = badgeProps[status] || badgeProps.Incomplete;
                        return (
                            <Badge color={props.color} pill className="px-3">
                                {props.icon} {status}
                            </Badge>
                        );
                    };

                    return (
                        <tbody key={index1}>
                            <tr 
                                id="activityName" 
                                onClick={toggleDataHandler}
                                className={`activity-row cursor-pointer border-start border-${statusColor} border-4`}
                            >
                                <td className="py-3">
                                    <div className="d-flex align-items-center">
                                        {tickMark}
                                        <div className="ms-3">
                                            <span className="fw-bold text-dark">{row1.m_desc}</span>
                                            <div className="text-muted small">
                                                Progress: {completedCount}/{totalCount} fields
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="py-3">
                                    <div className="d-flex align-items-center">
                                        <FaCalendarAlt className="text-info me-2" size={14} />
                                        <span className="fw-semibold">{date_format(row1.seq_cal_day)}</span>
                                    </div>
                                </td>
                                <td className="py-3">
                                    {getStatusBadge(status)}
                                </td>
                            </tr>
                            <div className="table-responsive subActivity toggle-content">
                                <div className="sub-table-container p-3 bg-light border-bottom">
                                    <table className="table table-sm mb-0">
                                        <thead>
                                            <tr className="bg-white">
                                                <th className="border-0 text-muted">Measuring Sub-field</th>
                                                <th className="border-0 text-muted">Recommend Value</th>
                                                <th className="border-0 text-muted">Actual Value</th>
                                                <th className="border-0 text-muted">Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>{pop_msrng_id}</tbody>
                                    </table>
                                </div>
                            </div>
                        </tbody>
                    )
                }
            });
            setReport(pop_m_p_details);
        } else {
            let msg = (
                <tr>
                    <td colSpan="3" className="text-center py-5">
                        <div className="empty-state">
                            <FaClipboardList size={48} className="text-muted mb-3" />
                            <Alert color="warning" className="border-0 bg-light">
                                <h6 className="mb-2">No Traceability Data Found</h6>
                                <p className="mb-0 text-muted">Traceability details are not available for this batch.</p>
                            </Alert>
                        </div>
                    </td>
                </tr>
            );
            setReport(msg);
        }
    }

    const get_extra_activity_list = () => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "crop_veriety": data.crop_variety_code, "lang_id": 1, }];
        axios({
            method: 'post',
            url: mainurl + 'Traceability/extra_activity_web',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    const activityIcons = {
                        10001: <BiLeaf size={32} className="text-success" />,
                        10002: <BiLeaf size={32} className="text-success" />,
                        10003: <BiDroplet  size={32} className="text-info" />,
                        10004: <FaTractor size={32} className="text-warning" />,
                        10005: <FaSeedling size={32} className="text-primary" />,
                        10006: <BiTestTube size={32} className="text-danger" />,
                        10007: <FaChartLine size={32} className="text-dark" />,
                        10008: <FaEye size={32} className="text-secondary" />,
                        10009: <FaClipboardList size={32} className="text-info" />
                    };

                    return (
                        <Col lg={2} md={3} sm={4} xs={6} className="mb-3" key={index}>
                            <div 
                                className='activity-card h-100 p-3 text-center border rounded-lg cursor-pointer hover-shadow transition-all'
                                onClick={() => extra_activity_handler(row.activity_id)}
                            >
                                <div className="activity-icon mb-2">
                                    {activityIcons[row.activity_id] || 
                                        <img src={imgurl + row.photo} alt="activity" className="activity-img" />
                                    }
                                </div>
                                <small className='fw-semibold text-dark'>{row.activity_name}</small>
                            </div>
                        </Col>
                    )
                });

                setExtraActList(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const show_soil_report = () => {
        let list = <SoilTest />
        setModalData(list);
        setViewModal(true);
    }

    const date_format = (val) => {
        let dt = val.split(" ")[0].split('-').reverse().join('-');
        return dt;
    }

    const extra_activity_handler = (act_id) => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "batch_id": data.batch_no, "activity_type": act_id, }];
        axios({
            method: 'post',
            url: mainurl + 'Traceability/trace_extra_activity_view',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data === null) {
                    let notify = notification({ message: "No Data Found!", type: 'warn' });
                    notify();
                    return;
                }

                if (Number(act_id) < 10003) {
                    setModalTitle('Harvest Data');
                    let list = response.data.map((row, index) => {
                        return {
                            sl: index + 1,
                            h_date: row.activity_date.split('-').reverse().join('-'),
                            name: row.harvest_crop_name,
                            value: row.value + ' ' + row.uom_desc
                        }
                    });
                    setModalData(<HarvestData h_data={list} />);
                    setViewModal(true);
                }
                
                if (Number(act_id) === 10006) {
                    setModalTitle('Fertilizer Data');
                    let list = response.data.map((row, index) => {
                        return {
                            sl: index + 1,
                            h_date: row.activity_date.split('-').reverse().join('-'),
                            name: row.fertilizer_name,
                            value: row.value + ' ' + row.uom_desc
                        }
                    });
                    setModalData(<HarvestData h_data={list} />);
                    setViewModal(true);
                }
                
                if (Number(act_id) > 10002 && Number(act_id) !== 10006) {
                    const titles = {
                        10003: 'Irrigation Details',
                        10004: 'Weeding Details',
                        10005: 'Inter Culture Details',
                        10007: 'Disease Details',
                        10008: 'Image Details',
                        10009: 'Advisory Details'
                    };
                    
                    setModalTitle(titles[Number(act_id)] || 'Activity Details');
                    
                    let list = response.data.map((row, index) => {
                        return {
                            sl: index + 1,
                            name: row.activity_name,
                            h_date: row.activity_date.split('-').reverse().join('-')
                        }
                    });
                    setModalData(<ExtraActivity h_data={list} />);
                    setViewModal(true);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const InfoCard = ({ icon, label, value, color = "primary" }) => (
        <Col lg={2} md={3} sm={4} xs={6} className="mb-3">
            <div className={`info-card border-start border-${color} border-4 ps-3 py-2 bg-light rounded-end h-100`}>
                <div className="d-flex align-items-center mb-1">
                    {icon && <span className={`text-${color} me-2`}>{icon}</span>}
                    <small className="text-muted fw-semibold text-uppercase">{label}</small>
                </div>
                <h6 className="mb-0 text-dark fw-bold">{value || 'N/A'}</h6>
            </div>
        </Col>
    );

    return (
        <div className="traceability-container">
            {/* Header Section */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="text-primary mb-1 fw-bold">
                        <FaChartLine className="me-2" />
                        Crop Traceability Report
                    </h4>
                    <p className="text-muted mb-0">Complete farming lifecycle tracking and analysis</p>
                </div>
                <Badge color="info" className="px-3 py-2 fs-6">
                    Batch: {data.batch_no}
                </Badge>
            </div>

            {/* Farmer Details Card */}
            <Card className='mb-4 shadow-sm border-0'>
                <CardHeader className="bg-gradient bg-primary text-white border-0">
                    <div className="d-flex align-items-center">
                        <FaUser className="me-2" />
                        <h5 className="mb-0">Farmer Information</h5>
                    </div>
                </CardHeader>
                <CardBody className="p-4">
                    <Row>
                        <InfoCard 
                            icon={<FaUser />} 
                            label="Farmer Name" 
                            value={data.f_name} 
                            color="primary" 
                        />
                        <InfoCard 
                            label="Farmer ID" 
                            value={data.farmer_code} 
                            color="secondary" 
                        />
                        <InfoCard 
                            icon={<FaMapMarkerAlt />} 
                            label="State" 
                            value={data.state_name} 
                            color="info" 
                        />
                        <InfoCard 
                            label="District" 
                            value={data.dist_name} 
                            color="info" 
                        />
                        <InfoCard 
                            label="Block" 
                            value={data.block_name} 
                            color="info" 
                        />
                        <InfoCard 
                            label="Village" 
                            value={data.vill_name} 
                            color="info" 
                        />
                        <InfoCard 
                            icon={<FaSeedling />} 
                            label="Season" 
                            value="Kharif" 
                            color="success" 
                        />
                        <InfoCard 
                            label="Crop Variety" 
                            value={data.crop_variety_name} 
                            color="warning" 
                        />
                        <InfoCard 
                            icon={<FaCalendarAlt />} 
                            label="Sowing Date" 
                            value={data.pop_start_date?.split(" ")[0].split('-').reverse().join('-')} 
                            color="dark" 
                        />
                    </Row>
                </CardBody>
            </Card>

            {/* Cultivation Activities */}
            <Card className='mb-4 shadow-sm border-0'>
                <CardHeader className="bg-gradient bg-success text-white border-0">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <FaTractor className="me-2" />
                            <h5 className="mb-0">Cultivation Activities</h5>
                        </div>
                        <Badge color="light" className="text-success">
                            Farm Operations
                        </Badge>
                    </div>
                </CardHeader>
                <CardBody className="p-4">
                    <Row>
                        {extraActList || (
                            <Col xs={12} className="text-center py-4">
                                <FaTractor size={48} className="text-muted mb-3" />
                                <p className="text-muted">Loading cultivation activities...</p>
                            </Col>
                        )}
                    </Row>
                </CardBody>
            </Card>

            {/* Measuring Report */}
            <Card className='mb-4 shadow-sm border-0'>
                <CardHeader className="bg-gradient bg-warning text-white border-0">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <FaClipboardList className="me-2" />
                            <h5 className="mb-0">Field Monitoring Report</h5>
                        </div>
                        <Badge color="light" className="text-warning">
                            Activity Tracking
                        </Badge>
                    </div>
                </CardHeader>
                <CardBody className="p-0">
                    <div className="table-responsive">
                        <table className="table mb-0 modern-table">
                            <thead className="bg-light">
                                <tr>
                                    <th className="border-0 py-3 px-4 fw-semibold text-dark">Measuring Field</th>
                                    <th className="border-0 py-3 px-4 fw-semibold text-dark">Recommend Date</th>
                                    <th className="border-0 py-3 px-4 fw-semibold text-dark">Status</th>
                                </tr>
                            </thead>
                            {report}
                        </table>
                    </div>
                </CardBody>
            </Card>

            {/* Activity Details Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="modern-modal"
            >
                <ModalHeader 
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-gradient bg-primary text-white border-0"
                >
                    <div className="d-flex align-items-center">
                        <FaEye className="me-2" />
                        {modalTitle}
                    </div>
                </ModalHeader>
                <ModalBody className="p-4">
                    {modalData}
                </ModalBody>
            </Modal>

            <style jsx>{`
            
                .traceability-container {
                    background: #fff;
                    min-height: 100vh;
                    padding: 20px;
                }

                .info-card {
                    transition: all 0.3s ease;
                    min-height: 80px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .info-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                }

                .activity-card {
                    background: white;
                    transition: all 0.3s ease;
                    border: 2px solid #e9ecef !important;
                    min-height: 120px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }

                .activity-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                    border-color: #007bff !important;
                }

                .activity-img {
                    width: 32px;
                    height: 32px;
                    object-fit: contain;
                }

                .activity-icon {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 50px;
                    height: 50px;
                    background: #f8f9fa;
                    border-radius: 50%;
                    margin: 0 auto;
                }

                .activity-row {
                    transition: all 0.3s ease;
                    background: white;
                }

                .activity-row:hover {
                    background: #f8f9fa !important;
                    transform: translateX(4px);
                }

                .sub-detail-row {
                    background: white;
                    border-bottom: 1px solid #f0f0f0;
                }

                .sub-detail-row:last-child {
                    border-bottom: none;
                }

                .sub-table-container {
                    margin: 0 1rem;
                    border-radius: 8px;
                    box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
                }

                .toggle-content {
                    display: none;
                    opacity: 0;
                    transition: all 0.3s ease;
                }

                .toggle-content.is-visible {
                    display: block;
                    opacity: 1;
                }

                .status-indicator {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    display: inline-block;
                }

                .status-indicator.pending {
                    background: #ffc107;
                    border: 2px solid #e0a800;
                }

                .modern-table tbody tr {
                    border: none;
                }

                .modern-table tbody tr:hover {
                    background: rgba(0,123,255,0.05);
                }

                .bg-gradient {
                    background: linear-gradient(135deg, var(--bs-primary) 0%, rgba(var(--bs-primary-rgb), 0.8) 100%);
                }

                .bg-gradient.bg-success {
                    background: linear-gradient(135deg, var(--bs-success) 0%, rgba(var(--bs-success-rgb), 0.8) 100%);
                }

                .bg-gradient.bg-warning {
                    background: linear-gradient(135deg, var(--bs-warning) 0%, rgba(var(--bs-warning-rgb), 0.8) 100%);
                }

                .bg-gradient.bg-info {
                    background: linear-gradient(135deg, var(--bs-info) 0%, rgba(var(--bs-info-rgb), 0.8) 100%);
                }

                .cursor-pointer {
                    cursor: pointer;
                }

                .hover-shadow:hover {
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }

                .transition-all {
                    transition: all 0.3s ease;
                }

                .empty-state {
                    text-align: center;
                    padding: 2rem;
                }

                .modern-modal .modal-content {
                    border: none;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 10px 40px rgba(0,0,0,0.2);
                }

                @media (max-width: 768px) {
                    .traceability-container {
                        padding: 10px;
                    }
                    
                    .activity-card {
                        min-height: 100px;
                    }
                    
                    .info-card {
                        min-height: 70px;
                    }
                }
            `}</style>
        </div>
    )
}

export default TraceabilityDetail;